(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name vcuser.vcuser.factory:UserHelper
   *
   * @description
   *
   */
  angular
    .module('vcuser.vcuser')
    .factory('UserHelper', UserHelper);


  UserHelper.$inject = ['User', '$uibModal', '$log', 'Rlog'];

  function UserHelper(User, $uibModal, $log, Rlog) {
    let UserHelperBase = {};

    UserHelperBase.editUser = editUser;
    UserHelperBase.addUser = addUser;


    function addUser(success, error) {
      let dialog = $uibModal.open({
        template: '<div class="modalspacer"><userform user="vm.user" parentsave="vm.childsave(user)" oncancel="vm.cancel()"></usernew></div>',
        controllerAs: 'useraCtrl',
        controller: ['user', function () {
          let vm = this;
          vm.user = {};

          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(user) {
            User.$create(user).$then(function (newuser) {
              vm.created = true;
              success(newuser);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ user-helper.addUser: ', err);
              Rlog.error('vcutils.user', 'user-helper.addUser', 'Creation of new user failed: ', {
                user: user
              });
              error(err);
              dialog.close();
            });
          }

          function cancel() {
            dialog.close();
          }

        }],
        resolve: {
          user: function () {
            return {};
          }
        },
        size: 'lg'
      });
    }


    function editUser(luser, lroles) {
      let dialog = $uibModal.open({
        template: `
          <div class="modalspacer">
              <userform user="usereCtrl.user" parentsave="usereCtrl.childsave(user)" oncancel="usereCtrl.cancel()" roles="usereCtrl.roles"></userform>
          </div>
        `,
        controllerAs: 'usereCtrl',
        controller: ['user', 'roles', function (luser, lroles) {
          let vm = this;
          vm.user = luser;
          vm.roles = lroles;
          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(user) {
            // vm.user = angular.copy(user);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (let key in user) {
              if (user.hasOwnProperty(key)) {
                vm.user[key] = user[key];
              }
            }

            if (vm.user.$hasPendingActions()) {
              vm.user.$cancel();
              vm.user.$save();
              cancel();
            }
            else {
              vm.user.$save();
              dialog.close();
            }
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          user: function () {
            return luser;
          },
          roles: function () {
            return lroles;
          }
        },
        size: 'lg'
      });
      return dialog;
    }

    return UserHelperBase;
  }
}());
